function initMobileMenu() {
  const button = document.getElementById("mobile-menu-button");
  const menu = document.getElementById("mobile-menu");
  if (!button || !menu) return;

  button.onclick = (event) => {
    event.stopPropagation();
    menu.classList.toggle("hidden");
    const open = !menu.classList.contains("hidden");
    button.setAttribute("aria-expanded", open ? "true" : "false");
  };
}

document.addEventListener("click", (event) => {
  const button = document.getElementById("mobile-menu-button");
  const menu = document.getElementById("mobile-menu");
  if (!button || !menu) return;
  if (!menu.contains(event.target) && !button.contains(event.target)) {
    menu.classList.add("hidden");
    button.setAttribute("aria-expanded", "false");
  }
});

document.addEventListener("DOMContentLoaded", initMobileMenu);
document.addEventListener("turbo:load", initMobileMenu);
